import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'
import { Row, Col, Card } from 'antd'
import LinearChartLive from '../../charts/LinearChartLive'
import FlowTable from '../../charts/FlowTable'
import { LoadingChart } from '../../utils/Utils'

class Volumen extends Component {
    render() {
        let { pulsos, pulsos_day, title } = this.props 
        let volume = pulsos.populated ? pulsos.data.map((arr) => [arr[0], arr[1]]) : []
        let volume_day = pulsos_day.populated ? pulsos_day.data.map((arr)=> [arr[0], (arr[1]*0.01).toFixed(2)]) : []

        return (
            <Row type='flex' justify='left' gutter={8} style={{ padding: '10px' }}>
              <Col span={24} align='center' >
                <Card bodyStyle={{ padding: '0' }} >
                  {pulsos.populated
                    ? <LinearChartLive
                      unit='m³/h'
                      title={title}
                      data={volume}
                      lastValue={[pulsos.lastUpdate, pulsos.lastValue]}
                      color='#faad14'
                      ylabel='Cubic Meters per Hour'
                      type='spline' />
                    : <LoadingChart />
                  }
                </Card>
              </Col>
              <Col md={18} xs={24}>
                <Card bodyStyle={{ padding: '5px' }} style={{ marginTop: '10px' }}>
                  <FlowTable
                    delta={0}   
                    pageSize={7}
                    unit='m³'
                    title='VOLUMEN UMBITA'
                    data={volume_day.slice(0, -1)}
                    current={volume_day[volume_day.length - 1] ? volume_day[volume_day.length - 1][1] : null}
                  />
                </Card>
              </Col>
            </Row>
          )
    }

}

Volumen.propTypes = {
    title: PropTypes.string,
    lastValue: PropTypes.number,
    lastUpdate: PropTypes.number,
    data: PropTypes.array,
    populated: PropTypes.bool
}

function mapStateToProps(state) {
    let { umbita } = state.locations
    return {
        pulsos: umbita.indicators.pulsos,
        pulsos_day: umbita.indicators.acumulate_pulsos,
        title: `Volumen Umbita`,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Volumen)



// WEBPACK FOOTER //
// ./src/boards/umbita/Volumen.js